import classNames from 'classnames';
import {observer, PropTypes as MobxPropTypes} from 'mobx-react';
import PropTypes from 'prop-types';
import React from 'react';

import {onClickEntityEvent} from '../utils';

/**
 * The DisplayFeedImage component.
 */
export class DisplayFeedImage extends React.Component {
  /**
   * Renders the component.
   *
   * @returns {{}}
   */
  render() {
    const {entity, game, style, topStyle, className, onEntityClick} = this.props;

    const entityId = entity.get('id');
    const feedimage = entity.get('feedimage');

    if (!feedimage.url) {
      return null;
    }

    const imageSource = feedimage.url;

    const imageId = `display-feed-image-el-${entityId}`;

    const onClickEvent = onClickEntityEvent(game, entity, onEntityClick);

    return (
      <div
        id={entityId}
        className={classNames('display-feed-image', className)}
        style={{
          ...topStyle,
          pointerEvents: 'none',
        }}
      >
        <div
          style={{
            ...style,
            opacity: feedimage.opacity
          }}
        >
          <img
            id={imageId}
            height={style.height}
            width={style.width}
            src={imageSource}
            style={{
              cursor: onClickEvent ? 'pointer' : 'inherit',
              pointerEvents: 'auto',
              objectFit: 'contain',
            }}
            onClick={onClickEvent}
          />
        </div>
      </div>
    );
  }
}

DisplayFeedImage.propTypes = {
  entity: MobxPropTypes.observableMap.isRequired,
  game: MobxPropTypes.observableObject.isRequired,
  style: PropTypes.object.isRequired,
  topStyle: PropTypes.object.isRequired,

  className: PropTypes.string,
  onEntityClick: PropTypes.func,
};

export default observer(DisplayFeedImage);
